import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4aefd24b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "body" }
const _hoisted_2 = {
  key: 0,
  class: "spinner"
}
const _hoisted_3 = { class: "mt-1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "*Цена с учётом розничной цены АЗС", -1))
const _hoisted_6 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDecimal = _resolveComponent("VDecimal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isRequestInProgress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _renderSlot(_ctx.$slots, "name", {}, () => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.name), 1)
          ], true),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.address), 1),
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prices, (price) => {
              return (_openBlock(), _createElementBlock("li", {
                key: price.fuel.code,
                class: "d-flex justify-space-between"
              }, [
                _createElementVNode("span", null, _toDisplayString(price.fuel.code), 1),
                _createElementVNode("div", null, [
                  _createVNode(_component_VDecimal, {
                    value: price.price,
                    class: "ml-2"
                  }, null, 8, ["value"]),
                  _createTextVNode("₽")
                ])
              ]))
            }), 128))
          ])
        ], 64))
  ], 512))
}